import { render } from "./Wheel1.vue?vue&type=template&id=ad442940"
const script = {}
script.render = render

export default script